import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

import styles from "./Message.module.scss";

interface CopyButtonProps {
  content: string;
}

export default function CopyButton({ content }: CopyButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`${styles.copyButton} absolute top-0 right-0 pointer bn bg-transparent ph3 pv3 o-50`}
      style={{
        fontSize: "16px",
      }}
    >
      <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} className="mr1" />
    </button>
  );
}
